<template>
  <TemplateBase>
    <div class="grid grid-cols-12 bg-white sm:bg-transparent">
      <section v-if="image" class="col-span-full row-start-1 bg-white sm:bg-transparent z-0 v-margin-page-image-to-page-content">
        <MoleculeMaskVisual :image="image" />
      </section>

      <OrganismPageSectionContent
        class="row-start-2 col-span-full mb-8 md:mb-12"
        :at-page-top="!image"
        :title="title"
        :subtitle="subtitle"
        :introduction="introduction"
        :description="description"
      />
    </div>
  </TemplateBase>
</template>

<script setup lang="ts">
defineProps({
  description: { type: String, required: false, default: undefined },
  image: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  introduction: { type: String, required: false, default: undefined },
  subtitle: { type: String, required: false, default: undefined },
  title: { type: String, required: false, default: undefined },
})
</script>
